/** Duración de clase: en BD son horas decimales; en UI se usa HH:MM. */

/** 2.5 → "02:30"; 1 → "01:00" */
export function hoursToDurationInput(hours) {
  const h = Number(hours);
  if (!Number.isFinite(h) || h <= 0) return '';
  const totalMin = Math.round(h * 60);
  const hh = Math.floor(totalMin / 60);
  const mm = totalMin % 60;
  return `${String(hh).padStart(2, '0')}:${String(mm).padStart(2, '0')}`;
}

/** "02:30" → 2.5; "01:00" → 1 (redondeado a 2 decimales para DecimalField max_digits=5) */
export function durationInputToHours(timeStr) {
  const s = String(timeStr || '').trim();
  if (!s) return 0;
  const [hhRaw, mmRaw] = s.split(':');
  const hh = parseInt(hhRaw, 10);
  const mm = parseInt(mmRaw, 10);
  if (!Number.isFinite(hh) || hh < 0) return 0;
  const minutes = Number.isFinite(mm) && mm >= 0 ? mm : 0;
  const hours = hh + minutes / 60;
  return Math.round(hours * 100) / 100;
}

/** Texto para mostrar: 2.5 → "2:30 h"; si no hay valor → "" */
export function formatDuracionClase(hours) {
  const t = hoursToDurationInput(hours);
  if (!t) return '';
  const [hh, mm] = t.split(':');
  const hNum = parseInt(hh, 10);
  const mNum = parseInt(mm, 10);
  if (mNum === 0) return `${hNum} h`;
  return `${hNum}:${String(mNum).padStart(2, '0')} h`;
}
